import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const DollarQuotationEdit = () =>
  import(/* webpackChunkName: "dollar-quotations" */ '@/views/DollarQuotations/Edit.vue');
const DollarQuotationList = () =>
  import(/* webpackChunkName: "dollar-quotations" */ '@/views/DollarQuotations/List.vue');

let dollarQuotationsPages = {
  path: '/dollar-quotations',
  redirect: '/dollar-quotations',
  component: DashboardLayout,
  name: 'DollarQuotations',
  meta: {
    title: 'Cotizaciones de dólar',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'DollarQuotationList',
      meta: {
        title: 'Listado',
        auth: ['dollar_quotations.index'],
      },
      component: DollarQuotationList,
    },
    {
      path: ':id/edit',
      name: 'DollarQuotationEdit',
      meta: {
        title: 'Editar',
        auth: ['dollar_quotations.update'],
      },
      component: DollarQuotationEdit,
    },
  ],
};

export default dollarQuotationsPages;
